export const blockIconsTravelGiteNew = (
	<span className='material-symbols-outlined'>gite</span>
);
